
import React from 'react'

const ArticleGuestPostHeading = ({ author }) => (
  <p className="special-quote">
    <b>Guest post:</b> This article is a guest post by blogger, {author}.
  </p>
)

export default ArticleGuestPostHeading;